import React, { useState } from "react";
import close from "../Assets/Images/close.png";
import up from "../Assets/Images/chevron right.png";

const UnitPublishing = ({ handleClose, setIsModalOpen }) => {
  const [selectedCard, setSelectedCard] = useState(null);

  const getCardStyle = (index) => {
    if (selectedCard === null) {
      return "opacity-100";
    }
    return selectedCard === index
      ? "opacity-100 scale-105 shadow-xl "
      : "opacity-50";
  };

  return (
    <div className="flex flex-col justify-start items-start border-[1px] border-[#F0F0F5] w-[90%] sm:w-[553px] mt-[30px] mx-auto mb-[30px] h-[431px] rounded-[14px] shadow-xl relative bg-white">
      <div className="absolute top-5 right-6 cursor-pointer">
        <img
          src={close}
          alt="Close"
          className=" curvsor-pointer w-6 h-6"
          onClick={handleClose}
        />
      </div>
      <div className="flex mt-[50px] flex-col justify-start items-center w-full h-full">
        <h2 className="text-[16px] text-[#9c9c9e] font-[400] mb-4">
          Publish To
        </h2>
        <div className="flex flex-col gap-[20px]">
          <div
            className={`w-[489px] h-[70px] items-center flex justify-between p-5 rounded-[14px] border-[1px] border-[#f0f0f5] shadow-md transition-transform duration-300 cursor-pointer ${getCardStyle(
              1
            )}`}
            onClick={() => {
              setIsModalOpen({ modal: "CONFIRMATION" });
            }}
          >
            <div className="text-[16px] font-[500] text-[#131E3D]">All</div>
            <img src={up} alt="" className="w-[20px] h-[20px]" />
          </div>
          <div
            className={`w-[489px] h-[70px] items-center flex justify-between p-5 rounded-[14px] border-[1px] border-[#f0f0f5] shadow-md transition-transform duration-300 cursor-pointer ${getCardStyle(
              1
            )}`}
            onClick={() => {
              setIsModalOpen({ modal: "SELECTED_USER" });
            }}
          >
            <div className="text-[16px] font-[500] text-[#131E3D]">
              Selected Users
            </div>
            <img src={up} alt="" className="w-[20px] h-[20px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitPublishing;
